import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import NotificationsList from '@/components/NotificationsList';

/**
 * Página dedicada de notificações (/notificacoes).
 * Resolve o caso de deep-link/bookmark — o popover do sidebar continua existindo
 * pra "espiada rápida". Padrão híbrido tipo Gmail/Slack.
 */
const NotificationsPage: FC = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <header className="mb-6 flex items-center gap-4">
        <button
          onClick={() => navigate(-1)}
          className="text-content-muted hover:text-content-primary transition-colors"
          aria-label="Voltar"
        >
          <span className="material-symbols-outlined">arrow_back</span>
        </button>
        <div>
          <h1 className="text-2xl font-bold text-content-primary">Notificações</h1>
          <p className="text-sm text-content-muted">Histórico completo de atividades</p>
        </div>
      </header>

      <div className="bg-surface-secondary rounded-2xl border border-theme-border overflow-hidden">
        <NotificationsList variant="page" />
      </div>
    </div>
  );
};

export default NotificationsPage;
